const buildDialogActionCreator = (type) => (message, options) => ({
  type: globalUiAction.OPEN_MODAL,
  payload: { message, type, options },
  callback: message.callback,
})

export const globalUiAction = {
  SET_GLOBAL_UI: "SET_GLOBAL_UI",
  GLOBAL_DATA_REQUEST: "GLOBAL_DATA_REQUEST",

  OPEN_MODAL: "OPEN_MODAL",

  setGlobalUI: (data) => ({
    type: globalUiAction.SET_GLOBAL_UI,
    payload: data,
  }),

  fetchGlobalData: (name, requestData, loading) => ({
    type: globalUiAction.GLOBAL_DATA_REQUEST,
    payload: { name: name, requestData: requestData, loading: loading },
  }),

  openInfoModal: buildDialogActionCreator("info"),

  openErrorModal: buildDialogActionCreator("error"),

  openWarningModal: buildDialogActionCreator("warning"),

  openConfirmModal: buildDialogActionCreator("confirm"),

  openSuccessModal: buildDialogActionCreator("success"),
}
